import axiosInstance from '../utils/axiosInstance';

const getDataResult = (response) => response.data?.data ?? response.data ?? {};

// List doors for a school (by school Mikrotik IP)
export const listDoorsForSchool = async (ip) => {
  if (!ip) throw new Error('IP школы не указан');
  const response = await axiosInstance.get(`/hikvision/schools/${encodeURIComponent(ip)}/devices`);
  return Array.isArray(getDataResult(response)) ? getDataResult(response) : [];
};

// Create a new door device for a school
export const createDoor = async (ip, body) => {
  if (!ip) throw new Error('IP школы не указан');
  const response = await axiosInstance.post(
    `/hikvision/schools/${encodeURIComponent(ip)}/devices`,
    body
  );
  return getDataResult(response);
};

// Update a door device
export const updateDoor = async (id, body) => {
  if (!id) throw new Error('ID устройства не указан');
  const response = await axiosInstance.put(`/hikvision/devices/${id}`, body);
  return getDataResult(response);
};

// Delete a door device
export const deleteDoor = async (id) => {
  if (!id) throw new Error('ID устройства не указан');
  const response = await axiosInstance.delete(`/hikvision/devices/${id}`);
  return getDataResult(response);
};

// Get door overview (device info + current metrics)
export const fetchDoorOverview = async (id) => {
  if (!id) throw new Error('ID устройства не указан');
  const response = await axiosInstance.get(`/hikvision/devices/${id}/overview`);
  return getDataResult(response);
};

// Get door metrics series for charts
export const fetchDoorSeries = async (id, range = '24h') => {
  if (!id) throw new Error('ID устройства не указан');
  const response = await axiosInstance.get(`/hikvision/devices/${id}/series`, {
    params: { range },
  });
  return getDataResult(response);
};

// Register stream and get WebRTC signaling URL
// channel: streaming profile for door/panic (101/102) OR camera number for NVR
// options.profile: 'sub' | 'main' (NVR only)
export const fetchDeviceStream = async (id, channel, options = {}) => {
  if (!id) throw new Error('ID устройства не указан');
  const params = {};
  if (channel) params.channel = channel;
  if (options.profile) params.profile = options.profile;
  const response = await axiosInstance.get(`/hikvision/devices/${id}/stream`, {
    params: Object.keys(params).length ? params : undefined,
  });
  return getDataResult(response);
};

// Fetch snapshot as blob URL (caller must revoke when done)
export const fetchDeviceSnapshotBlob = async (id, channel, options = {}) => {
  if (!id) throw new Error('ID устройства не указан');
  const params = {};
  if (channel) params.channel = channel;
  if (options.profile) params.profile = options.profile;
  const response = await axiosInstance.get(`/hikvision/devices/${id}/snapshot`, {
    params: Object.keys(params).length ? params : undefined,
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
};

export const getSnapshotUrl = (id, channel) => {
  const apiBase = process.env.REACT_APP_API_URL || '';
  const token = localStorage.getItem('authToken') || '';
  const params = new URLSearchParams();
  if (channel) params.set('channel', channel);
  if (token) params.set('token', token);
  const qs = params.toString();
  return `${apiBase}/hikvision/devices/${id}/snapshot${qs ? `?${qs}` : ''}`;
};

/** NVR channel list (from Prometheus labels, live fallback on backend). */
export const fetchNvrChannels = async (id) => {
  if (!id) throw new Error('ID устройства не указан');
  const response = await axiosInstance.get(`/hikvision/devices/${id}/channels`);
  return getDataResult(response);
};

/** Probe ISAPI deviceInfo with the credentials from the add-device form. */
export const checkDeviceReachability = async (body) => {
  const response = await axiosInstance.post('/hikvision/devices/check-reachability', body, {
    timeout: 20000,
  });
  return getDataResult(response);
};
